define('app/views/_cms_business_page_view',['app/setup'],
  function(takhfifan) {
  takhfifan.cmsBusinessPageView = Backbone.View.extend({
    events: {
    },
    initialize: function(options) {
      this.$('.categories ul li span').html('');
    }
  });
});

